<template>
  <div class="container my-0 mx-auto category-footer">
    <div
      class="grid lg:grid-flow-row md:grid-flow-row lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-2 xxs:grid-cols-2">
      <div v-for="image in images" :key="image"
        class="teaser lg:m-3 xs:m-1 xxs:m-1 lg:p-2 xs:p-1 xxs:p-1">
        <router-link
          :to="`/praemien/kategorie/${categoryUrls[image.name]}`"
          @click="redirectToCategoryPage(image.name)"
          :title="`${image.name}` || 'Zur Kategorie'"
          :aria-label="`${image.name}` || 'Zur Kategorie'"
          tabindex="0"
        >
          <image-gallery
            :image="image.path"
            :alt="`Gehe zu ${image.name}` || 'Zur Kategorie'"
          >
          </image-gallery>
          <p class="text-center centered middled">{{ image.name }}</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ImageGallery from "@/components/Image/ImageGallery";
import { reactive, onMounted, ref, computed } from "vue";
import constants from "@/helpers/constants";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import EventBus from "@/helpers/event-bus";
export default {
  name: "CategoriesFooter",
  setup() {
    const images = reactive([]);
    const router = useRouter();
    const store = useStore();
    const categoryUrls = ref(constants.CATEGORY_URLS);

    onMounted(() => {
      importImages();
    });

    const importImages = async () => {
      // Use Vite's import.meta.glob for dynamic imports
      const imageModules = import.meta.glob('@/assets/footer-categories/*.{png,jpg,jpeg,svg}', { eager: true });
      
      for (const imagePath in imageModules) {
        // imageModules[imagePath] is a module, get the default export (the image URL)
        const module = imageModules[imagePath];
        const path = module.default || module;
        const name = getImageName(imagePath);

        const image = {
          path: path,
          name: name,
        };

        images.push(image);
      }
    };

    const getImageName = (imagePath) => {
      const specialCharacterMap = {
        "Alle Pramien": "Alle Prämien",
        "Bucher & Zeitschriften": "Bücher & Zeitschriften",
        "Kindertraume & Spiele": "Kinderträume & Spiele",
        "Neue Pramien": "Neue Prämien",
      };
      // Extract filename from full path (e.g., "@/assets/footer-categories/image.png" -> "image.png")
      const imageNameWithExtension = imagePath.split("/").pop();
      const imageNameWithoutExtension = imageNameWithExtension.split(".")[0];
      return (
        specialCharacterMap[imageNameWithoutExtension] ||
        imageNameWithoutExtension
      );
    };

    const allCategories = computed(() => {
      return store.getters["catalog/getCategories"];
    });

    const redirectToCategoryPage = (categoryName) => {
      store.dispatch("catalog/setFooterCategoryClick", true);

      const filteredCategories = allCategories?.value.children?.find(
        (category) => category.name === categoryName
      );
      EventBus.emit("footerCategoryClicked", {
        category: filteredCategories,
        type: "parentCategory",
        toggleCall: false,
      });
    };

    return {
      images,
      categoryUrls,
      redirectToCategoryPage,
    };
  },
  components: {
    ImageGallery,
  },
};
</script>
<style>
.middled {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
}

.category-footer img {
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 767px) {
  .middled {
    font-size: 11px;
  }
}

.category-footer .teaser {
  position: relative;
  box-shadow: inset 0 0 0 5px #fff;
  transition: box-shadow 0.3s ease-in-out;
  cursor: pointer;
}

.teaser {
  a {
    background: #0046aa;
    color:#fff;
  }

  &:hover {
    box-shadow: inset 0 0 0 5px #bfcbdd;
  }
}
</style>
